export const addressType = [
  {
    text: 'Seleccione el tipo de vía',
    key: ''
  },
  {
    text: 'Alameda',
    key: 'AL'
  },
  {
    text: 'Apartamento',
    key: 'AP'
  },
  {
    text: 'Avenida',
    key: 'AV'
  },
  {
    text: 'Barrio',
    key: 'BA'
  },
  {
    text: 'Barrio',
    key: 'BO'
  },
  {
    text: 'Bloque',
    key: 'BL'
  },
  {
    text: 'Calle',
    key: 'CL'
  },
  {
    text: 'Camino',
    key: 'CM'
  },
  {
    text: 'Carretera',
    key: 'CR'
  },
  {
    text: 'Caserio',
    key: 'CS'
  },
  {
    text: 'Chalet',
    key: 'CH'
  },
  {
    text: 'Colonia',
    key: 'CO'
  },
  {
    text: 'Cuesta',
    key: 'CT'
  },
  {
    text: 'Debajo del Puente',
    key: 'DP'
  },
  {
    text: 'Desconocida',
    key: 'ZZ'
  },
  {
    text: 'Edificio',
    key: 'ED'
  },
  {
    text: 'Glorieta',
    key: 'GL'
  },
  {
    text: 'Grupo',
    key: 'GR'
  },
  {
    text: 'Lugar',
    key: 'LG'
  },
  {
    text: 'Manzana',
    key: 'MZ'
  },
  {
    text: 'Mercado',
    key: 'MC'
  },
  {
    text: 'Parque',
    key: 'PQ'
  },
  {
    text: 'Pasaje',
    key: 'PJ'
  },
  {
    text: 'Paseo',
    key: 'PS'
  },
  {
    text: 'Plaza',
    key: 'PZ'
  },
  {
    text: 'Polígono',
    key: 'PG'
  },
  {
    text: 'Prolongación',
    key: 'PR'
  },
  {
    text: 'Rambla',
    key: 'RB'
  },
  {
    text: 'RESIDENCIAL',
    key: 'RS'
  },
  {
    text: 'Ronda',
    key: 'RD'
  },
  {
    text: 'Travesía',
    key: 'TR'
  },
  {
    text: 'Urbanización',
    key: 'UR'
  },
  {
    text: 'Vista',
    key: 'VI'
  }
];

export const provinces = [
  {
    text: 'Seleccione la provincia',
    key: ''
  },
  {
    text: 'Alava',
    key: '1'
  },
  {
    text: 'Albacete',
    key: '2'
  },
  {
    text: 'Alicante',
    key: '3'
  },
  {
    text: 'Almería',
    key: '4'
  },
  {
    text: 'Asturias',
    key: '33'
  },
  {
    text: 'Avila',
    key: '5'
  },
  {
    text: 'Badajoz',
    key: '6'
  },
  {
    text: 'Baleares',
    key: '7'
  },
  {
    text: 'Barcelona',
    key: '8'
  },
  {
    text: 'BILBAO',
    key: '53'
  },
  {
    text: 'Burgos',
    key: '9'
  },
  {
    text: 'Cantabria',
    key: '39'
  },
  {
    text: 'Castellón',
    key: '12'
  },
  {
    text: 'Ceuta',
    key: '51'
  },
  {
    text: 'Ciudad Real',
    key: '13'
  },
  {
    text: 'Cuenca',
    key: '16'
  },
  {
    text: 'Cáceres',
    key: '10'
  },
  {
    text: 'Cádiz',
    key: '11'
  },
  {
    text: 'Córdoba',
    key: '14'
  },
  {
    text: 'Errónea',
    key: '0'
  },
  {
    text: 'Extranjero',
    key: '99'
  },
  {
    text: 'Gerona',
    key: '17'
  },
  {
    text: 'Granada',
    key: '18'
  },
  {
    text: 'Guadalajara',
    key: '19'
  },
  {
    text: 'Guipúzcoa',
    key: '20'
  },
  {
    text: 'Huelva',
    key: '21'
  },
  {
    text: 'Huesca',
    key: '22'
  },
  {
    text: 'Jaén',
    key: '23'
  },
  {
    text: 'La Coruña',
    key: '15'
  },
  {
    text: 'La Rioja',
    key: '26'
  },
  {
    text: 'Las Palmas',
    key: '35'
  },
  {
    text: 'León',
    key: '24'
  },
  {
    text: 'Lugo',
    key: '27'
  },
  {
    text: 'Lérida',
    key: '25'
  },
  {
    text: 'Madrid',
    key: '28'
  },
  {
    text: 'Melilla',
    key: '52'
  },
  {
    text: 'Murcia',
    key: '30'
  },
  {
    text: 'Málaga',
    key: '29'
  },
  {
    text: 'Navarra',
    key: '31'
  },
  {
    text: 'Orense',
    key: '32'
  },
  {
    text: 'Palencia',
    key: '34'
  },
  {
    text: 'Pontevedra',
    key: '36'
  },
  {
    text: 'Residencia en extranjero',
    key: '98'
  },
  {
    text: 'Salamanca',
    key: '37'
  },
  {
    text: 'Santa Cruz De Tenerife',
    key: '38'
  },
  {
    text: 'Segovia',
    key: '40'
  },
  {
    text: 'Sevilla',
    key: '41'
  },
  {
    text: 'Soria',
    key: '42'
  },
  {
    text: 'Tarragona',
    key: '43'
  },
  {
    text: 'Teruel',
    key: '44'
  },
  {
    text: 'Toledo',
    key: '45'
  },
  {
    text: 'Valencia',
    key: '46'
  },
  {
    text: 'Valladolid',
    key: '47'
  },
  {
    text: 'Vizcaya',
    key: '48'
  },
  {
    text: 'Zamora',
    key: '49'
  },
  {
    text: 'Zaragoza',
    key: '50'
  }
];

export const countries = [
  {
    text: 'Seleccione el país',
    key: ''
  },
  {
    text: 'AFGANISTAN',
    key: '660'
  },
  {
    text: 'ALBANIA',
    key: '070'
  },
  {
    text: 'ALEMANIA',
    key: '004'
  },
  {
    text: 'ANDORRA',
    key: '043'
  },
  {
    text: 'ANGOLA (INC.CABINDA)',
    key: '330'
  },
  {
    text: 'ANGUILLA',
    key: '446'
  },
  {
    text: 'ANTIGUA Y BARBUDA',
    key: '459'
  },
  {
    text: 'ANTILLAS NEERLANDESAS',
    key: '478'
  },
  {
    text: 'ANTÁRTIDA',
    key: '023'
  },
  {
    text: 'APATRIDAS Y REFUGIADOS',
    key: '998'
  },
  {
    text: 'ARABIA SAUDITA',
    key: '632'
  },
  {
    text: 'ARGELIA',
    key: '208'
  },
  {
    text: 'ARGENTINA',
    key: '528'
  },
  {
    text: 'ARUBA',
    key: '474'
  },
  {
    text: 'AUSTRALIA',
    key: '800'
  },
  {
    text: 'AUSTRIA',
    key: '038'
  },
  {
    text: 'AZERBAYAN',
    key: '031'
  },
  {
    text: 'BAHAMAS',
    key: '453'
  },
  {
    text: 'BAHREIN',
    key: '640'
  },
  {
    text: 'BANGLADESH',
    key: '666'
  },
  {
    text: 'BARBADOS',
    key: '469'
  },
  {
    text: 'BELARUS',
    key: '112'
  },
  {
    text: 'BELGICA',
    key: '002'
  },
  {
    text: 'BELLIZE',
    key: '421'
  },
  {
    text: 'BENIN',
    key: '204'
  },
  {
    text: 'BENIN',
    key: '284'
  },
  {
    text: 'BERMUDAS',
    key: '413'
  },
  {
    text: 'BHOUTAN',
    key: '675'
  },
  {
    text: 'BIRMANIA',
    key: '676'
  },
  {
    text: 'BOLIVIA',
    key: '516'
  },
  {
    text: 'BOSNIA-HERZEGOVINA',
    key: '071'
  },
  {
    text: 'BOTSWANA',
    key: '391'
  },
  {
    text: 'BOUVET (ISLA)',
    key: '074'
  },
  {
    text: 'BRASIL',
    key: '508'
  },
  {
    text: 'BRUNEI',
    key: '703'
  },
  {
    text: 'BULGARIA',
    key: '068'
  },
  {
    text: 'BURKINA-FASO(ALTO VOLTA)',
    key: '236'
  },
  {
    text: 'BURUNDI',
    key: '328'
  },
  {
    text: 'CAMERUN',
    key: '302'
  },
  {
    text: 'CANADA',
    key: '404'
  },
  {
    text: 'CHECOSLOVAQUIA',
    key: '062'
  },
  {
    text: 'CHILE',
    key: '512'
  },
  {
    text: 'CHINA',
    key: '720'
  },
  {
    text: 'CHIPRE',
    key: '600'
  },
  {
    text: 'CHRISTMAS (ISLA)',
    key: '162'
  },
  {
    text: 'CIUDAD DEL VATICANO',
    key: '045'
  },
  {
    text: 'COCOS, KEELING (ISLAS)',
    key: '166'
  },
  {
    text: 'COLOMBIA',
    key: '480'
  },
  {
    text: 'COMORES GRAN COMORE',
    key: '375'
  },
  {
    text: 'CONGO',
    key: '318'
  },
  {
    text: 'COREA (REPPÚBLICA P. DEMOCRÁTICA)',
    key: '407'
  },
  {
    text: 'COREA DEL SUR',
    key: '728'
  },
  {
    text: 'COSTA DE MARFIL',
    key: '272'
  },
  {
    text: 'COSTA RICA',
    key: '188'
  },
  {
    text: 'CROACIA',
    key: '161'
  },
  {
    text: 'CUBA',
    key: '448'
  },
  {
    text: 'DESCONOCIDO CON CONVENIO',
    key: '955'
  },
  {
    text: 'DESCONOCIDO SIN CONVENIO',
    key: '954'
  },
  {
    text: 'DINAMARCA',
    key: '008'
  },
  {
    text: 'DJIBOUTI',
    key: '338'
  },
  {
    text: 'DOMINICA',
    key: '460'
  },
  {
    text: 'ECUADOR E ISLAS GALAPAGOS',
    key: '500'
  },
  {
    text: 'EGIPTO',
    key: '220'
  },
  {
    text: 'EL SALVADOR',
    key: '428'
  },
  {
    text: 'EMIRATOS ARABES UNIDOS',
    key: '647'
  },
  {
    text: 'ERITREA',
    key: '230'
  },
  {
    text: 'ESLOVAQUIA',
    key: '065'
  },
  {
    text: 'ESLOVENIA',
    key: '705'
  },
  {
    text: 'ESPAÑA',
    key: '011'
  },
  {
    text: 'ESTADOS UNIDOS DE AMERICA',
    key: '400'
  },
  {
    text: 'ESTONIA',
    key: '053'
  },
  {
    text: 'ETIOPIA',
    key: '334'
  },
  {
    text: 'FIDJI',
    key: '815'
  },
  {
    text: 'FILIPINAS',
    key: '708'
  },
  {
    text: 'FINLANDIA (INC.ISLAS ALAND)',
    key: '032'
  },
  {
    text: 'FRANCIA',
    key: '001'
  },
  {
    text: 'GABON',
    key: '314'
  },
  {
    text: 'GAMBIA',
    key: '252'
  },
  {
    text: 'GEORGIA',
    key: '267'
  },
  {
    text: 'GEORGIA DEL SUR E ISLAS SANDWICH',
    key: '239'
  },
  {
    text: 'GHANA',
    key: '276'
  },
  {
    text: 'GIBRALTAR',
    key: '044'
  },
  {
    text: 'GRANADA E ISLAS GRANADA DEL SUR',
    key: '473'
  },
  {
    text: 'GRECIA',
    key: '009'
  },
  {
    text: 'GROENLANDIA',
    key: '406'
  },
  {
    text: 'GUADALUPE',
    key: '458'
  },
  {
    text: 'GUATEMALA',
    key: '416'
  },
  {
    text: 'GUINEA',
    key: '260'
  },
  {
    text: 'GUINEA ECUATORIAL',
    key: '310'
  },
  {
    text: 'GUINEA-BISSAU',
    key: '257'
  },
  {
    text: 'GUYANA',
    key: '488'
  },
  {
    text: 'GUYANA FRANCESA',
    key: '496'
  },
  {
    text: 'HAITI',
    key: '452'
  },
  {
    text: 'HEARD Y McDONALD (ISLAS)',
    key: '333'
  },
  {
    text: 'HONDURAS E ISLAS SWAN',
    key: '424'
  },
  {
    text: 'HONG-KONG',
    key: '740'
  },
  {
    text: 'HUNGRIA',
    key: '064'
  },
  {
    text: 'INDIA (INC. SIKKIM)',
    key: '664'
  },
  {
    text: 'INDONESIA',
    key: '700'
  },
  {
    text: 'IRAN',
    key: '616'
  },
  {
    text: 'IRAQ',
    key: '612'
  },
  {
    text: 'IRLANDA',
    key: '007'
  },
  {
    text: 'ISLA DE MAN',
    key: '095'
  },
  {
    text: 'ISLANDIA',
    key: '024'
  },
  {
    text: 'ISLAS CAYMAN',
    key: '463'
  },
  {
    text: 'ISLAS COOK',
    key: '818'
  },
  {
    text: 'ISLAS DE JERSEY Y GUERNESEY',
    key: '091'
  },
  {
    text: 'ISLAS FEROE',
    key: '025'
  },
  {
    text: 'ISLAS MALVINAS (FALKLANDS) Y DEPENDS.',
    key: '529'
  },
  {
    text: 'ISLAS MARIANAS',
    key: '805'
  },
  {
    text: 'ISLAS MARSHALL',
    key: '584'
  },
  {
    text: 'ISLAS MENORES ALEJADAS DE EE.UU.',
    key: '581'
  },
  {
    text: 'ISLAS PITCAIRN',
    key: '813'
  },
  {
    text: 'ISLAS SALOMON',
    key: '806'
  },
  {
    text: 'ISLAS TURQUESAS Y CAICOS',
    key: '454'
  },
  {
    text: 'ISLAS VIRGENES BRITANICAS Y MONSE.',
    key: '461'
  },
  {
    text: 'ISLAS VIRGENES DE LOS EE.UU.',
    key: '457'
  },
  {
    text: 'ISLAS WALLIS Y FUTUNA (INC.ALORI)',
    key: '811'
  },
  {
    text: 'ISRAEL',
    key: '624'
  },
  {
    text: 'ITALIA',
    key: '005'
  },
  {
    text: 'JAMAICA',
    key: '464'
  },
  {
    text: 'JAPON',
    key: '732'
  },
  {
    text: 'JORDANIA',
    key: '628'
  },
  {
    text: 'KAMPUCHEA (CAMBOYA)',
    key: '696'
  },
  {
    text: 'KAZAKSTAN',
    key: '398'
  },
  {
    text: 'KENYA',
    key: '346'
  },
  {
    text: 'KIRGHIZISTAN',
    key: '417'
  },
  {
    text: 'KIRIBATI',
    key: '812'
  },
  {
    text: 'KUWAIT',
    key: '636'
  },
  {
    text: 'LAOS',
    key: '684'
  },
  {
    text: 'LESOTHO',
    key: '395'
  },
  {
    text: 'LIBANO',
    key: '604'
  },
  {
    text: 'LIBERIA',
    key: '268'
  },
  {
    text: 'LIBIA',
    key: '216'
  },
  {
    text: 'LIECHTENSTEIN',
    key: '092'
  },
  {
    text: 'LITUANIA',
    key: '063'
  },
  {
    text: 'LUXEMBURGO',
    key: '012'
  },
  {
    text: 'MACAO',
    key: '743'
  },
  {
    text: 'MADAGASCAR',
    key: '370'
  },
  {
    text: 'MALASIA (SARAWAK',
    key: '701'
  },
  {
    text: 'MALAWI',
    key: '386'
  },
  {
    text: 'MALDIVAS (ISLAS)',
    key: '667'
  },
  {
    text: 'MALI',
    key: '232'
  },
  {
    text: 'MALTA (INC.GOZO Y COMINO)',
    key: '046'
  },
  {
    text: 'MARRUECOS',
    key: '100'
  },
  {
    text: 'MARTINICA',
    key: '462'
  },
  {
    text: 'MAURICIO',
    key: '373'
  },
  {
    text: 'MAURITANIA',
    key: '228'
  },
  {
    text: 'MAYOTTE',
    key: '377'
  },
  {
    text: 'MEXICO',
    key: '412'
  },
  {
    text: 'MICRONESIA',
    key: '583'
  },
  {
    text: 'MONACO',
    key: '093'
  },
  {
    text: 'MONGOLIA',
    key: '716'
  },
  {
    text: 'MONSERRAT',
    key: '499'
  },
  {
    text: 'MOZAMBIQUE',
    key: '366'
  },
  {
    text: 'MYANMAR',
    key: '104'
  },
  {
    text: 'NAMIBIA',
    key: '389'
  },
  {
    text: 'NAURU',
    key: '803'
  },
  {
    text: 'NEPAL',
    key: '672'
  },
  {
    text: 'NICARAGUA E ISLAS CORN',
    key: '432'
  },
  {
    text: 'NIGER',
    key: '240'
  },
  {
    text: 'NIGERIA',
    key: '288'
  },
  {
    text: 'NIUE',
    key: '570'
  },
  {
    text: 'NORFOLK (ISLA)',
    key: '574'
  },
  {
    text: 'NORUEGA',
    key: '028'
  },
  {
    text: 'NUEVA CALEDONIA Y DEPENDENCIAS',
    key: '809'
  },
  {
    text: 'NUEVA ZELANDA',
    key: '804'
  },
  {
    text: 'OCEANIA AMERICANA',
    key: '808'
  },
  {
    text: 'OCEANIA AUSTRALIANA',
    key: '802'
  },
  {
    text: 'OCEANIA NEOZELANDESA',
    key: '814'
  },
  {
    text: 'OMAN',
    key: '649'
  },
  {
    text: 'OTROS PAISES DE AFRICA NO RELACIONADOS',
    key: '399'
  },
  {
    text: 'OTROS PAISES DE AMERICA NO RELACIONADOS',
    key: '599'
  },
  {
    text: 'OTROS PAISES DE ASIA NO RELACIONADOS',
    key: '799'
  },
  {
    text: 'OTROS PAISES DE EUROPA NO RELACIONADOS',
    key: '099'
  },
  {
    text: 'OTROS PAISES DE OCEANIA NO RELACIONADOS',
    key: '899'
  },
  {
    text: 'PAISES BAJOS',
    key: '003'
  },
  {
    text: 'PAKISTAN',
    key: '662'
  },
  {
    text: 'PALAU',
    key: '585'
  },
  {
    text: 'PANAMA(INCLUYE ANTIGUA ZONA  CANAL)',
    key: '442'
  },
  {
    text: 'PAPUA-NUEVA GUINEA',
    key: '801'
  },
  {
    text: 'PARAGUAY',
    key: '520'
  },
  {
    text: 'PAÍS DESCONOCIDO',
    key: '953'
  },
  {
    text: 'PERU',
    key: '504'
  },
  {
    text: 'POLINESIA FRANCESA',
    key: '822'
  },
  {
    text: 'POLONIA',
    key: '489'
  },
  {
    text: 'POLONIA',
    key: '060'
  },
  {
    text: 'PORTUGAL (INC.AZORES Y MADEIRA)',
    key: '010'
  },
  {
    text: 'PUERTO RICO',
    key: '401'
  },
  {
    text: 'QATAR',
    key: '644'
  },
  {
    text: 'REGIONES POLARES',
    key: '890'
  },
  {
    text: 'REINO UNIDO',
    key: '006'
  },
  {
    text: 'REPUBLICA CENTRO AFRICANA',
    key: '306'
  },
  {
    text: 'REPUBLICA DE CABO VERDE',
    key: '247'
  },
  {
    text: 'REPUBLICA DOMINICANA',
    key: '456'
  },
  {
    text: 'REPUBLICA DOMINICANA',
    key: '039'
  },
  {
    text: 'REPÚBLICA CHECA',
    key: '061'
  },
  {
    text: 'REPÚBLICA DE MOLDAVIA',
    key: '498'
  },
  {
    text: 'REUNION',
    key: '372'
  },
  {
    text: 'RUMANIA',
    key: '066'
  },
  {
    text: 'RUSIA',
    key: '056'
  },
  {
    text: 'RWANDA',
    key: '324'
  },
  {
    text: 'SAHARA OCCIDENTAL',
    key: '733'
  },
  {
    text: 'SAMOA AMERICANA',
    key: '016'
  },
  {
    text: 'SAMOA OCCIDENTALES',
    key: '819'
  },
  {
    text: 'SAN CRISTOBAL Y NEVIS',
    key: '449'
  },
  {
    text: 'SAN MARINO',
    key: '094'
  },
  {
    text: 'SAN PEDRO Y MIQUELON',
    key: '408'
  },
  {
    text: 'SAN VICENTE E ISLAS GRANADA DEL N.',
    key: '467'
  },
  {
    text: 'SANTA HELENA Y DEPENDENCIAS',
    key: '329'
  },
  {
    text: 'SANTA LUCIA',
    key: '465'
  },
  {
    text: 'SANTO TOME Y PRINCIPE',
    key: '311'
  },
  {
    text: 'SENEGAL',
    key: '248'
  },
  {
    text: 'SEYCHELLES Y DEPENDENCIAS',
    key: '355'
  },
  {
    text: 'SIERRA LEONA',
    key: '264'
  },
  {
    text: 'SINGAPUR',
    key: '706'
  },
  {
    text: 'SIRIA (REPÚBLICA ÁRABE)',
    key: '608'
  },
  {
    text: 'SOMALIA',
    key: '342'
  },
  {
    text: 'SRI LANKA',
    key: '669'
  },
  {
    text: 'SUDAFRICA',
    key: '388'
  },
  {
    text: 'SUDAN',
    key: '224'
  },
  {
    text: 'SUECIA',
    key: '030'
  },
  {
    text: 'SUIZA (INC.BUSINGEN Y CAMPIONE)',
    key: '036'
  },
  {
    text: 'SURINAM',
    key: '492'
  },
  {
    text: 'SVALBARD E ISLA JUAN MAYEN',
    key: '029'
  },
  {
    text: 'SWAZILAND',
    key: '393'
  },
  {
    text: 'TADJIKISTAN',
    key: '762'
  },
  {
    text: 'TAIWAN',
    key: '736'
  },
  {
    text: 'TANZANIA',
    key: '352'
  },
  {
    text: 'TCHAD',
    key: '244'
  },
  {
    text: 'TERR. ANT. REP. YUGOSLAVA DE MACEDONIA',
    key: '956'
  },
  {
    text: 'TERRITORIO BRIT. DEL OC. INDICO',
    key: '357'
  },
  {
    text: 'THAILANDIA',
    key: '680'
  },
  {
    text: 'TIERRAS AUSTRALES FRANCESAS',
    key: '261'
  },
  {
    text: 'TIMOR',
    key: '626'
  },
  {
    text: 'TOGO',
    key: '280'
  },
  {
    text: 'TOKELAU',
    key: '772'
  },
  {
    text: 'TONGA',
    key: '817'
  },
  {
    text: 'TRINIDAD Y TOBAGO',
    key: '472'
  },
  {
    text: 'TUNEZ',
    key: '212'
  },
  {
    text: 'TURQUESTAN',
    key: '795'
  },
  {
    text: 'TURQUIA',
    key: '052'
  },
  {
    text: 'TUVALU',
    key: '807'
  },
  {
    text: 'UCRANIA',
    key: '067'
  },
  {
    text: 'UGANDA',
    key: '350'
  },
  {
    text: 'URUGUAY',
    key: '524'
  },
  {
    text: 'UZBEKISTAN',
    key: '860'
  },
  {
    text: 'VANUATU',
    key: '816'
  },
  {
    text: 'VENEZUELA',
    key: '484'
  },
  {
    text: 'VIETNAM',
    key: '690'
  },
  {
    text: 'YEMEN',
    key: '653'
  },
  {
    text: 'YUGOSLAVIA',
    key: '048'
  },
  {
    text: 'ZAIRE',
    key: '322'
  },
  {
    text: 'ZAMBIA',
    key: '378'
  },
  {
    text: 'ZIMBABWE',
    key: '382'
  }
];

const addressData = {
  addressType,
  provinces,
  countries
};

export const getDataFormatted = (abbreviation, type) =>
  addressData[type].find(item => item.key === abbreviation).text;
